<div class="payment-report-wrapper">
  <h2>Betalningsrapport</h2>

  <!-- Datepicker -->
  <div>
    <mat-form-field>
      <mat-label>Välj period</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Startdatum" [formControl]="from">
        <input matEndDate placeholder="Slutdatum" [formControl]="to">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <!-- Chart -->
  @if (!loadingData && !setEmpty) {
    <app-stat-barchart [chartData]="chartDataSet" [titleArray]="chartTitles" [colorArray]="chartColors"></app-stat-barchart>
  }

  <!-- Table -->
  @if (!setEmpty) {
    <div class="report-table-scroll" tabindex="0" role="region"
      aria-label="Tabell för betalningsrapport">
      <table mat-table [dataSource]="paymentReport">
        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef>Betalningsmetod</th>
          <td mat-cell *matCellDef="let report" [ngClass]="{'total': report.label === 'Total'}">{{report.label}}</td>
          <td mat-footer-cell *matFooterCellDef>Total </td>
        </ng-container>
        <ng-container matColumnDef="payments">
          <th mat-header-cell *matHeaderCellDef class="number-data">Betalningar</th>
          <td mat-cell *matCellDef="let report" [ngClass]="{'total': report.label === 'Total'}" class="number-data">{{report.payments | number: '' : 'sv'}} kr</td>
          <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('payments') | number: "1.0-0"}} kr</td>
        </ng-container>
        <ng-container matColumnDef="refunds">
          <th mat-header-cell *matHeaderCellDef class="number-data">Återbetalningar</th>
          <td mat-cell *matCellDef="let report" [ngClass]="{'total': report.label === 'Total'}" class="number-data">{{report.refunds | number: '' : 'sv'}} kr</td>
          <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('refunds') | number: "1.0-0"}} kr</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['method', 'payments', 'refunds']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['method', 'payments', 'refunds']"></tr>
        <tr mat-footer-row *matFooterRowDef="['method', 'payments', 'refunds']"></tr>
      </table>
    </div>
  }


  <!-- Empty set info -->
  @if (setEmpty && !loadingData) {
    <div class="{{!errorMessage ? 'empty-content' : 'error-content'}}">
      <p>{{errorMessage ? 'Någonting gick fel, kunde inte hämta data för den valda perioden.' :
      'Det finns inga data för den valda perioden.'}}</p>
    </div>
  }

  <!-- Spinner -->
  @if (loadingData) {
    <div>
      <mat-spinner class="spinner"></mat-spinner>
    </div>
  }
</div>